const CARD_ITEMS = [
  {
    title: '《我独自升级》',
    tag: '完结神作',
    desc: '从最弱到最强，成肖宇的逆袭之路让全球读者为之疯狂。韩国漫画史上最具影响力的作品之一，累计阅读量超百亿。',
    rating: '9.8',
    image: 'https://readdy.ai/api/search-image?query=Dark%20fantasy%20Korean%20manhwa%20style%20character%20illustration%20with%20shadow%20warrior%20theme%2C%20dramatic%20lighting%2C%20purple%20and%20black%20gradient%2C%20digital%20art%2C%20manga%20webtoon%20style%2C%20no%20text%2C%20clean%20background&width=600&height=800&seq=card-01&orientation=portrait',
  },
  {
    title: '《全知读者视角》',
    tag: '人气连载',
    desc: '当小说世界变为现实，唯一读过结局的金独子能否改变命运？脑洞大开的设定与紧凑的剧情令人上瘾。',
    rating: '9.6',
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20fantasy%20illustration%20with%20constellation%20and%20golden%20light%20theme%2C%20mystical%20atmosphere%2C%20warm%20amber%20toned%2C%20digital%20art%2C%20no%20text%2C%20clean%20background&width=600&height=800&seq=card-02&orientation=portrait',
  },
  {
    title: '《甜蜜家园》',
    tag: '经典推荐',
    desc: '末世背景下的生存恐怖故事，人性与怪物的边界在哪里？已被Netflix改编为热门韩剧，原作漫画同样精彩绝伦。',
    rating: '9.4',
    image: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20horror%20survival%20style%20illustration%20with%20apocalyptic%20building%20theme%2C%20dark%20atmosphere%20with%20warm%20accent%20lighting%2C%20digital%20art%2C%20no%20text%2C%20clean%20background&width=600&height=800&seq=card-03&orientation=portrait',
  },
  {
    title: '《女神降临》',
    tag: '浪漫经典',
    desc: '化妆变身女神的校园浪漫故事，细腻描绘了青春期的自卑与成长。韩国最受欢迎的浪漫喜剧漫画之一。',
    rating: '9.3',
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20romance%20style%20illustration%20with%20beauty%20and%20makeup%20theme%2C%20soft%20pink%20and%20coral%20tones%2C%20digital%20art%2C%20dreamy%20atmosphere%2C%20no%20text%2C%20clean%20background&width=600&height=800&seq=card-04&orientation=portrait',
  },
  {
    title: '《神之塔》',
    tag: '长篇巨制',
    desc: '攀登神秘高塔的少年，每一层都是全新的世界。宏大的世界观与独特的美术风格奠定了韩国漫画新高度。',
    rating: '9.5',
    image: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20tower%20theme%20illustration%20with%20mysterious%20climbing%20motif%2C%20grand%20scale%20and%20warm%20golden%20light%2C%20digital%20art%2C%20epic%20atmosphere%2C%20no%20text%2C%20clean%20background&width=600&height=800&seq=card-05&orientation=portrait',
  },
  {
    title: '《梨泰院Class》',
    tag: '励志佳作',
    desc: '在梨泰院开餐厅的创业故事，不向世界妥协的热血人生。改编韩剧风靡亚洲，原作漫画更加深刻动人。',
    rating: '9.2',
    image: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20restaurant%20business%20style%20illustration%20with%20neon%20night%20street%20theme%2C%20warm%20coral%20and%20amber%20lighting%2C%20digital%20art%2C%20modern%20atmosphere%2C%20no%20text%2C%20clean%20background&width=600&height=800&seq=card-06&orientation=portrait',
  },
];

export default function Cards() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-3">
          精选推荐
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-10">
          编辑团队精心挑选的高品质韩国漫画，每一部都值得阅读
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {CARD_ITEMS.map((card) => (
            <div
              key={card.title}
              className="bg-background-50 rounded-xl overflow-hidden cursor-pointer hover:scale-[1.02] transition-all duration-300"
            >
              <div className="relative h-64 overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover"
                />
                <span className="absolute top-3 left-3 px-3 py-1 rounded-full bg-accent-500/90 text-background-50 text-xs font-medium">
                  {card.tag}
                </span>
                <span className="absolute top-3 right-3 px-3 py-1 rounded-full bg-background-50/90 text-primary-600 text-xs font-bold">
                  {card.rating}
                </span>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-base font-bold text-foreground-900 mb-2">
                  {card.title}
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed line-clamp-3">
                  {card.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}